import React, { useEffect } from 'react';
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import noimg from '../dist/webImages/no_image.jpg';
import useDelete from '../customHooks/useDelete';
import { toast } from 'react-toastify';
import { StringConvert } from '../components/StringConvert';

const truncateText = (text, maxLength) => {
  if (text) {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + '...';
  }
  return text;
};

const AuthorsCard = ({ data, alldata, deleted }) => {
  const { id, image, name, designation, bio } = data;
  const [resDelete, apiMethodDelete] = useDelete();

  const handleDelete = () => {
    swal({
      title: 'Are you sure?',
      text: 'Are you sure that you want to delete this author?',
      buttons: true,
      icon: 'warning',
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        swal('Successfully Deleted', '', 'success');
        apiMethodDelete(`authors/${id}`);
      }
    });
  };

  useEffect(() => {
    if (resDelete.data) {
      const { message } = resDelete.data;
      const update = alldata.filter((item) => item.id !== id);
      deleted(update);
      toast.success(message);
    }
  }, [resDelete.data]);

  const truncatedBio = truncateText(bio, 180);

  return (
    <div className='lawyerCard h-full relative bg-[#fff] border border-[#D4DEF1] rounded-3xl shadow-custom p-4'>
      <div
        className='closeButton cursor-pointer absolute bg-[#FFCEDA] w-[2rem] h-[2rem] p-[.6rem] top-[.7rem] right-[.7rem] grid place-items-center rounded-[.7rem] z-10'
        onClick={handleDelete}
      >
        <svg className='w-full h-full' width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M15.8612 1.34766L0.951172 16.2567M15.8612 16.2577L0.951172 1.34863' stroke='#ED2656' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
      </div>

      <Link to={`/authors/edit/${id}`} className='cursor-pointer relative block'>
        <div className='lawyerCard_ flex items-center gap-4 pr-10'>
          <div className='lawyerCard__img'>
            <img
              className='h-[3.5rem] w-[3.5rem] object-cover rounded-full border-2 border-[#C0CCE2]'
              src={image}
              onError={(e) => { e.target.src = noimg; }}
              alt={name}
            />
          </div>
          <div className='lawyerCard__txt'>
            <div className='h2 text-[1.1rem] font-Mluvka leading-[1.2]'>{name}</div>
            <p className='leading-[1] mt-2 text-secondary text-[.8rem]'>{designation}</p>
          </div>
        </div>
        {truncatedBio && (
          <div className='text-[.85rem] text-[#3C3E56] mt-4 min-h-[4rem]'>{StringConvert(truncatedBio)}</div>
        )}
      </Link>
    </div>
  );
};

export default AuthorsCard;
